export default __webpack_public_path__ + "static/media/avatar_fairy_pixie7.71122c40.mp3";